import React, { useEffect, useState } from "react";
import ShimmerText from "./ShimmerText";

const ChatLoader = () => {
  const thinkingPhrases = [
    "Analyzing information",
    "Connecting concepts",
    "Synthesizing response",
    "Evaluating context",
    "Processing query",
  ];

  const [currentPhrase, setCurrentPhrase] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhrase((prev) => (prev + 1) % thinkingPhrases.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const mainColor = "#3E68FE";

  return (
    <div style={styles.container}>
      <ShimmerText text={thinkingPhrases[currentPhrase]} color={mainColor} />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    height: "60px",
    width: "100%",
    background: "transparent",
  },
};

export default ChatLoader;
